import { render, staticRenderFns } from "./ConfirmEmailChange.vue?vue&type=template&id=e971bf40&scoped=true"
import script from "./ConfirmEmailChange.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailChange.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmailChange.vue?vue&type=style&index=0&id=e971bf40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e971bf40",
  null
  
)

export default component.exports